require('../../modules/es6.number.min-safe-integer');
module.exports = -0x1fffffffffffff;



//////////////////
// WEBPACK FOOTER
// ./~/core-js/library/fn/number/min-safe-integer.js
// module id = 1558
// module chunks = 0